import api from "../services/api";

export const getVendor = (vendorId) => {
  return new Promise((resolve, reject) => {
    api
      .get(`vendors/${vendorId}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getVendorProfiles = (vendorId) => {
  return new Promise((resolve, reject) => {
    api
      .get(`vendors/${vendorId}/profiles`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const triggerResetPassword = (vendorId, email, vendorName, lng) => {
  return new Promise((resolve, reject) => {
    api
      .post(`users/vendor/${vendorId}/reset-password`, {
        vendorId: vendorId,
        email: email,
        vendorName: vendorName,
        lng:lng
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};
